/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PubliclayoutImport } from './routes/_public_layout'
import { Route as AuthedImport } from './routes/_authed'
import { Route as PubliclayoutIndexImport } from './routes/_public_layout/index'
import { Route as PubliclayoutLoginImport } from './routes/_public_layout/login'
import { Route as PubliclayoutEmailSentImport } from './routes/_public_layout/emailSent'
import { Route as AuthedFilledImport } from './routes/_authed/_filled'
import { Route as AuthedFilledSurveyImport } from './routes/_authed/_filled/survey'
import { Route as AuthedFilledProfileImport } from './routes/_authed/_filled/profile'
import { Route as AuthedFilledDashboardImport } from './routes/_authed/_filled/dashboard'
import { Route as AuthedFilledAnswersImport } from './routes/_authed/_filled/answers'
import { Route as AuthedFilledAgendaImport } from './routes/_authed/_filled/agenda'

// Create/Update Routes

const PubliclayoutRoute = PubliclayoutImport.update({
  id: '/_public_layout',
  getParentRoute: () => rootRoute,
} as any)

const AuthedRoute = AuthedImport.update({
  id: '/_authed',
  getParentRoute: () => rootRoute,
} as any)

const PubliclayoutIndexRoute = PubliclayoutIndexImport.update({
  path: '/',
  getParentRoute: () => PubliclayoutRoute,
} as any)

const PubliclayoutLoginRoute = PubliclayoutLoginImport.update({
  path: '/login',
  getParentRoute: () => PubliclayoutRoute,
} as any)

const PubliclayoutEmailSentRoute = PubliclayoutEmailSentImport.update({
  path: '/emailSent',
  getParentRoute: () => PubliclayoutRoute,
} as any)

const AuthedFilledRoute = AuthedFilledImport.update({
  id: '/_filled',
  getParentRoute: () => AuthedRoute,
} as any)

const AuthedFilledSurveyRoute = AuthedFilledSurveyImport.update({
  path: '/survey',
  getParentRoute: () => AuthedFilledRoute,
} as any)

const AuthedFilledProfileRoute = AuthedFilledProfileImport.update({
  path: '/profile',
  getParentRoute: () => AuthedFilledRoute,
} as any)

const AuthedFilledDashboardRoute = AuthedFilledDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => AuthedFilledRoute,
} as any)

const AuthedFilledAnswersRoute = AuthedFilledAnswersImport.update({
  path: '/answers',
  getParentRoute: () => AuthedFilledRoute,
} as any)

const AuthedFilledAgendaRoute = AuthedFilledAgendaImport.update({
  path: '/agenda',
  getParentRoute: () => AuthedFilledRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedImport
      parentRoute: typeof rootRoute
    }
    '/_public_layout': {
      id: '/_public_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PubliclayoutImport
      parentRoute: typeof rootRoute
    }
    '/_authed/_filled': {
      id: '/_authed/_filled'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedFilledImport
      parentRoute: typeof AuthedImport
    }
    '/_public_layout/emailSent': {
      id: '/_public_layout/emailSent'
      path: '/emailSent'
      fullPath: '/emailSent'
      preLoaderRoute: typeof PubliclayoutEmailSentImport
      parentRoute: typeof PubliclayoutImport
    }
    '/_public_layout/login': {
      id: '/_public_layout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PubliclayoutLoginImport
      parentRoute: typeof PubliclayoutImport
    }
    '/_public_layout/': {
      id: '/_public_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PubliclayoutIndexImport
      parentRoute: typeof PubliclayoutImport
    }
    '/_authed/_filled/agenda': {
      id: '/_authed/_filled/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AuthedFilledAgendaImport
      parentRoute: typeof AuthedFilledImport
    }
    '/_authed/_filled/answers': {
      id: '/_authed/_filled/answers'
      path: '/answers'
      fullPath: '/answers'
      preLoaderRoute: typeof AuthedFilledAnswersImport
      parentRoute: typeof AuthedFilledImport
    }
    '/_authed/_filled/dashboard': {
      id: '/_authed/_filled/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedFilledDashboardImport
      parentRoute: typeof AuthedFilledImport
    }
    '/_authed/_filled/profile': {
      id: '/_authed/_filled/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedFilledProfileImport
      parentRoute: typeof AuthedFilledImport
    }
    '/_authed/_filled/survey': {
      id: '/_authed/_filled/survey'
      path: '/survey'
      fullPath: '/survey'
      preLoaderRoute: typeof AuthedFilledSurveyImport
      parentRoute: typeof AuthedFilledImport
    }
  }
}

// Create and export the route tree

interface AuthedFilledRouteChildren {
  AuthedFilledAgendaRoute: typeof AuthedFilledAgendaRoute
  AuthedFilledAnswersRoute: typeof AuthedFilledAnswersRoute
  AuthedFilledDashboardRoute: typeof AuthedFilledDashboardRoute
  AuthedFilledProfileRoute: typeof AuthedFilledProfileRoute
  AuthedFilledSurveyRoute: typeof AuthedFilledSurveyRoute
}

const AuthedFilledRouteChildren: AuthedFilledRouteChildren = {
  AuthedFilledAgendaRoute: AuthedFilledAgendaRoute,
  AuthedFilledAnswersRoute: AuthedFilledAnswersRoute,
  AuthedFilledDashboardRoute: AuthedFilledDashboardRoute,
  AuthedFilledProfileRoute: AuthedFilledProfileRoute,
  AuthedFilledSurveyRoute: AuthedFilledSurveyRoute,
}

const AuthedFilledRouteWithChildren = AuthedFilledRoute._addFileChildren(
  AuthedFilledRouteChildren,
)

interface AuthedRouteChildren {
  AuthedFilledRoute: typeof AuthedFilledRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedFilledRoute: AuthedFilledRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PubliclayoutRouteChildren {
  PubliclayoutEmailSentRoute: typeof PubliclayoutEmailSentRoute
  PubliclayoutLoginRoute: typeof PubliclayoutLoginRoute
  PubliclayoutIndexRoute: typeof PubliclayoutIndexRoute
}

const PubliclayoutRouteChildren: PubliclayoutRouteChildren = {
  PubliclayoutEmailSentRoute: PubliclayoutEmailSentRoute,
  PubliclayoutLoginRoute: PubliclayoutLoginRoute,
  PubliclayoutIndexRoute: PubliclayoutIndexRoute,
}

const PubliclayoutRouteWithChildren = PubliclayoutRoute._addFileChildren(
  PubliclayoutRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthedFilledRouteWithChildren
  '/emailSent': typeof PubliclayoutEmailSentRoute
  '/login': typeof PubliclayoutLoginRoute
  '/': typeof PubliclayoutIndexRoute
  '/agenda': typeof AuthedFilledAgendaRoute
  '/answers': typeof AuthedFilledAnswersRoute
  '/dashboard': typeof AuthedFilledDashboardRoute
  '/profile': typeof AuthedFilledProfileRoute
  '/survey': typeof AuthedFilledSurveyRoute
}

export interface FileRoutesByTo {
  '': typeof AuthedFilledRouteWithChildren
  '/emailSent': typeof PubliclayoutEmailSentRoute
  '/login': typeof PubliclayoutLoginRoute
  '/': typeof PubliclayoutIndexRoute
  '/agenda': typeof AuthedFilledAgendaRoute
  '/answers': typeof AuthedFilledAnswersRoute
  '/dashboard': typeof AuthedFilledDashboardRoute
  '/profile': typeof AuthedFilledProfileRoute
  '/survey': typeof AuthedFilledSurveyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/_public_layout': typeof PubliclayoutRouteWithChildren
  '/_authed/_filled': typeof AuthedFilledRouteWithChildren
  '/_public_layout/emailSent': typeof PubliclayoutEmailSentRoute
  '/_public_layout/login': typeof PubliclayoutLoginRoute
  '/_public_layout/': typeof PubliclayoutIndexRoute
  '/_authed/_filled/agenda': typeof AuthedFilledAgendaRoute
  '/_authed/_filled/answers': typeof AuthedFilledAnswersRoute
  '/_authed/_filled/dashboard': typeof AuthedFilledDashboardRoute
  '/_authed/_filled/profile': typeof AuthedFilledProfileRoute
  '/_authed/_filled/survey': typeof AuthedFilledSurveyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/emailSent'
    | '/login'
    | '/'
    | '/agenda'
    | '/answers'
    | '/dashboard'
    | '/profile'
    | '/survey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/emailSent'
    | '/login'
    | '/'
    | '/agenda'
    | '/answers'
    | '/dashboard'
    | '/profile'
    | '/survey'
  id:
    | '__root__'
    | '/_authed'
    | '/_public_layout'
    | '/_authed/_filled'
    | '/_public_layout/emailSent'
    | '/_public_layout/login'
    | '/_public_layout/'
    | '/_authed/_filled/agenda'
    | '/_authed/_filled/answers'
    | '/_authed/_filled/dashboard'
    | '/_authed/_filled/profile'
    | '/_authed/_filled/survey'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  PubliclayoutRoute: typeof PubliclayoutRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  PubliclayoutRoute: PubliclayoutRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authed",
        "/_public_layout"
      ]
    },
    "/_authed": {
      "filePath": "_authed.tsx",
      "children": [
        "/_authed/_filled"
      ]
    },
    "/_public_layout": {
      "filePath": "_public_layout.tsx",
      "children": [
        "/_public_layout/emailSent",
        "/_public_layout/login",
        "/_public_layout/"
      ]
    },
    "/_authed/_filled": {
      "filePath": "_authed/_filled.tsx",
      "parent": "/_authed",
      "children": [
        "/_authed/_filled/agenda",
        "/_authed/_filled/answers",
        "/_authed/_filled/dashboard",
        "/_authed/_filled/profile",
        "/_authed/_filled/survey"
      ]
    },
    "/_public_layout/emailSent": {
      "filePath": "_public_layout/emailSent.tsx",
      "parent": "/_public_layout"
    },
    "/_public_layout/login": {
      "filePath": "_public_layout/login.tsx",
      "parent": "/_public_layout"
    },
    "/_public_layout/": {
      "filePath": "_public_layout/index.tsx",
      "parent": "/_public_layout"
    },
    "/_authed/_filled/agenda": {
      "filePath": "_authed/_filled/agenda.tsx",
      "parent": "/_authed/_filled"
    },
    "/_authed/_filled/answers": {
      "filePath": "_authed/_filled/answers.tsx",
      "parent": "/_authed/_filled"
    },
    "/_authed/_filled/dashboard": {
      "filePath": "_authed/_filled/dashboard.tsx",
      "parent": "/_authed/_filled"
    },
    "/_authed/_filled/profile": {
      "filePath": "_authed/_filled/profile.tsx",
      "parent": "/_authed/_filled"
    },
    "/_authed/_filled/survey": {
      "filePath": "_authed/_filled/survey.tsx",
      "parent": "/_authed/_filled"
    }
  }
}
ROUTE_MANIFEST_END */
